import { Box, VStack, HStack, SimpleGrid, Skeleton, SkeletonCircle, Text } from '@chakra-ui/react';
import TrendsChartSkeleton from './DashboardComponents/TrendsChartSkeleton';
import WholenessRingWithOverviewSkeleton from './WholenessRingWithOverviewSkeleton';

const OrganizationDashboardSkeleton = () => {
  return (
    <VStack width="100%" align="stretch" spacing="80px">
      <HStack spacing={'30px'}>
        <SkeletonCircle height={'100px'} width={'100px'} />
        <Text variant={'urbanistTitleMedium'}>Your Organization</Text>
      </HStack>
      <HStack spacing="20px">
        <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing="20px" w="full">
          {Array.from({ length: 7 }).map((_, i) => (
            <HStack
              key={i}
              width={'190px'}
              height={'128px'}
              borderRadius="14px"
              p="20px"
              bg="white"
              boxShadow="0px 10px 40px 0px #00417926"
              justifyContent={'space-between'}
            >
              <VStack align="start" height={'full'} justify={'space-between'}>
                <VStack align={'start'}>
                  <Skeleton height="8px" width="72px" />
                  <Skeleton height="8px" width="52px" />
                </VStack>
                <Skeleton height="36px" width="40px" borderRadius={'8px'} />
              </VStack>
              <VStack justify={'space-between'} align={'flex-end'} height={'full'} pt="4px">
                <SkeletonCircle height="20px" width={'20px'} />
                <Skeleton height="10px" width={'28px'} />
              </VStack>
            </HStack>
          ))}
        </SimpleGrid>
        <Box borderRadius="14px" p="20px" bg="white" boxShadow="0px 10px 40px 0px #00417926">
          <VStack align="start" w="full" spacing="20px" flex={1}>
            <HStack justifyContent={'space-between'} w={'full'} alignItems={'flex-end'}>
              <Skeleton height="18px" width="100px" borderRadius={'4px'} />
              <Skeleton height="12px" width="100px" borderRadius={'4px'} startColor="gray.200" endColor="gray.100" />
            </HStack>
            <HStack align="end" spacing="16px">
              <VStack spacing={'14px'}>
                <Skeleton height="172px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="76px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="40px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="95px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="68px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="136px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="62px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
              <VStack spacing={'14px'}>
                <Skeleton height="40px" width="32px" borderRadius={'10px'} />
                <Skeleton height="14px" width="32px" borderRadius={'8px'} />
              </VStack>
            </HStack>
          </VStack>
        </Box>
      </HStack>

      <WholenessRingWithOverviewSkeleton />

      <TrendsChartSkeleton />
    </VStack>
  );
};

export default OrganizationDashboardSkeleton;
